import { useState, useCallback } from 'react';

export const useSelection = <T extends { id: string }>(_items: T[]) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const toggleSelection = useCallback((id: string) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((selectedId) => selectedId !== id)
        : [...prev, id],
    );
  }, []);

  const togglePage = useCallback((pageItems: T[]) => {
    const pageIds = pageItems.map((item) => item.id);
    setSelectedIds((prev) => {
      const isAllSelected = pageIds.every((id) => prev.includes(id));
      if (isAllSelected) {
        return prev.filter((id) => !pageIds.includes(id));
      }
      return [...new Set([...prev, ...pageIds])];
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedIds([]);
  }, []);

  return {
    selectedIds,
    toggleSelection,
    togglePage,
    clearSelection,
    isSelected: useCallback(
      (id: string) => selectedIds.includes(id),
      [selectedIds],
    ),
  };
};
